import { type ChainFullId, type Contact, isSaplingAddress, parseChainFullId } from "@umami/chains";

export const getSuggestions = (
  inputValue: string,
  contacts: Contact[],
  chainId: ChainFullId,
  accountsType: "public" | "sapling" | "all" = "public"
): Contact[] => {
  const trimmedInput = inputValue.trim().toLowerCase();
  const { namespace } = parseChainFullId(chainId);

  const filtered = contacts.filter(contact => {
    const matchesInput = !trimmedInput || contact.name.toLowerCase().includes(trimmedInput);
    const matchesChain = contact.chainNamespace === namespace;

    const baseMatch = matchesInput && matchesChain;

    if (accountsType === "public") {
      return baseMatch && !isSaplingAddress(contact.pkh);
    }

    if (accountsType === "sapling") {
      return baseMatch && isSaplingAddress(contact.pkh);
    }

    return baseMatch;
  });

  // Remove duplicates based on pkh
  const uniqueContacts = filtered.reduce((acc: Contact[], contact) => {
    const existingContact = acc.find(c => c.pkh === contact.pkh);

    if (!existingContact) {
      acc.push(contact);
    }

    return acc;
  }, []);

  return uniqueContacts;
};
